import PageBody from './BodyWrapper'

export default function BodyLoading(){
    return(
        <div className="loading-body">
            <div className="cl a"></div>
            <div className="cl b"></div>
            <div className="cl c"></div>
        </div>
    )
}